import { TransactionsOutProps } from 'modules/clients/types/transaction-summary';
import styles from '../transaction-summary.module.scss';
import TransactionSummaryHeadingRow from 'modules/clients/components/atoms/transaction-summary-rows/TransactionSummaryHeadingRow';
import TransactionSummaryRow from 'modules/clients/components/atoms/transaction-summary-rows/TransactionSummaryRow';

const TransactionsOut = ({
  withdrawal,
  adminFee,
  adminFeeVat,
  intermediaryFee,
  intermediaryFeeVat
}: TransactionsOutProps) => {
  return (
    <div className={styles.container}>
      <TransactionSummaryHeadingRow
        testid='transactionSummaryTransactionsOut'
        data-testid='transactionSummaryTransactionOutHeadingRow'
        heading='Transactions: out'
      />
      <TransactionSummaryRow
        data-testid='transactionSummaryWithdrawalRow'
        heading='Withdrawal'
        amount={withdrawal}
        testid='transactionSummaryWithdrawal'
      />
      <TransactionSummaryRow
        data-testid='transactionSummaryAdminFeesRow'
        heading='Annual administration fees'
        amount={adminFee}
        testid='transactionSummaryAdminFees'
      />
      <TransactionSummaryRow
        data-testid='transactionSummaryAdminFeesVatRow'
        heading='VAT on annual administration fees'
        amount={adminFeeVat}
        testid='transactionSummaryAdminFeesVat'
      />
      <TransactionSummaryRow
        data-testid='transactionSummaryIntermediaryFeesRow'
        heading='Annual financial intermediary fees'
        amount={intermediaryFee}
        testid='transactionSummaryIntermediaryFees'
      />
      <TransactionSummaryRow
        data-testid='transactionSummaryIntermediaryFeesVatRow'
        heading='VAT on annual financial intermediary fees'
        amount={intermediaryFeeVat}
        testid='transactionSummaryIntermediaryFeesVat'
      />
    </div>
  );
};

export default TransactionsOut;
